import Reveal from './ui/Reveal.jsx';

export default function Pullquote() {
  return (
    <section
      data-screen-label="04 Werkwijze"
      style={{ background: 'var(--cream)', padding: 'var(--space-10) 0' }}
    >
      <Reveal
        style={{
          maxWidth: 980,
          margin: '0 auto',
          padding: '0 var(--gutter)',
          textAlign: 'left',
        }}
      >
        <div
          style={{
            fontFamily: 'var(--font-body)',
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'var(--ink-3)',
            marginBottom: 28,
          }}
        >
          Werkwijze
        </div>
        <p
          className="pullquote-text"
          style={{
            fontFamily: 'var(--font-display)',
            fontStyle: 'italic',
            fontWeight: 400,
            fontSize: 'clamp(32px, 3.4vw, 48px)',
            lineHeight: 1.25,
            letterSpacing: '-0.005em',
            color: 'var(--ink)',
            margin: 0,
            maxWidth: '28ch',
          }}
        >
          “Ik zie elke cliënt als een losstaand individu, met zijn of haar eigen krachten en
          kwaliteiten — die persoonlijke benadering maakt elke behandeling anders.”
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 32 }}>
          <div style={{ width: 36, height: 1, background: 'var(--ink-3)' }} />
          <div
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 12,
              fontWeight: 500,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'var(--ink-3)',
            }}
          >
            Maxime Duisterhof
          </div>
        </div>
      </Reveal>
    </section>
  );
}
